import React from 'react';
import Button from '../../../components/Button';
import { Link } from 'react-router-dom';
import frame from '../../../assets/frame.png';
import { BiSolidQuoteAltLeft } from 'react-icons/bi';
import { LuMoveRight } from 'react-icons/lu';
import elie from '../../../assets/elie.png';
import ghad from '../../../assets/ghad.png';
import emmanuel from '../../../assets/emmanuel.png';
import providence from '../../../assets/providence.png';
import valentine from '../../../assets/valentine.png';
import niyigaba from '../../../assets/niyigaba.png';
import niyomugabo from '../../../assets/niyomugabo.png';

import manirumva_samuel from '../../../assets/manirumva_samuel.jpeg';
import gisubizo_dinah from '../../../assets/gisubizo_dinah.jpeg';
import tumwitegure_joyeuse from '../../../assets/tumwitegure_joyeuse.jpeg';
import Partners from '../../partners/Partners';
import Footer from '../../../components/Footer';

const stories = [
  {
    id: 1,
    name: 'Manirumva Samuel',
    role: 'ASEF student',
    location: 'RWANDA',
    image: manirumva_samuel,
    date: 'Oct 17, 2025',
    message:
      '“We must keep asking ourselves how we are using education to transform lives and in how much time. An education that does not transform your life or the life of others is a wasted education.” \n— President Paul Kagame, speaking to 10,000 University of Rwanda students in 2015.',
  },
  {
    id: 2,
    name: 'Gisubizo Dinah',
    role: 'ASEF student',
    location: 'RWANDA',
    image: gisubizo_dinah,
    date: 'Oct 17, 2025',
    message:
      'From June 2nd to 5th, 2025, Rwanda hosted the National Skills Competition 2025, an event that brought together 93 top-performing students from Technical Secondary Schools (TSS) and Rwanda Polytechnic colleges across the country. The competition showcased outstanding talent and innovation in various disciplines, highlighting the growing importance of technical and vocational education in driving Rwanda’s development.',
  },
  {
    id: 3,
    name: 'Tumwitegure Joyeuse',
    role: 'ASEF student',
    location: 'RWANDA',
    image: tumwitegure_joyeuse,
    date: 'Oct 17, 2025',
    message:
      'Gashora Girls Academy of Science and Technology (GGAST) is one of Rwanda’s most prestigious high schools, located in Bugesera District. Known for its academic excellence and strong focus on science, technology, leadership, and innovation, the school has nurtured some of the brightest young women in the country.',
  },
  {
    id: 4,
    name: 'Iradukunda Providence',
    role: 'Executive Director at Youth Estimation for Peace and Development',
    location: 'RWANDA',
    image: providence,
    message:
      'I am Iradukunda Providence, a Rwandan female from Burera District, Cyanika Sector. I am the third of eleven children, raised by both my mother and father. I come from a financially humble family in the rural area of Cyanika. I attended GS Butete for primary school, where I excelled in the national examination and was sent to Gicumbi to study at Ecole Secondaire Sancta Maria Karambo. I spent three years there and performed well in the Ordinary Level examination, scoring 13 aggregates under the 2016 ranking system.',
  },
  {
    id: 5,
    name: 'Mugwaneza Valentine,',
    role: 'Secondary School Teacher',
    location: 'RWANDA',
    image: valentine,
    message:
      'Valentine is an ASEF graduate from Rulindo District. She was supported by ASEF throughout her six years of secondary school. She is the third of eight children and was raised by her mother alone, in a very financially vulnerable family.',
  },

  {
    id: 6,
    name: 'Niyigaba Jean Paul',
    role: ' Senior Auditor at BDO Rwanda',
    location: 'RWANDA',
    image: niyigaba,
    message:
      'Jean Paul Niyigaba is a proud Rwandan, born and raised from Kisaro Sector in Rulindo District. He is passionate about lifelong learning, hard work, and making a difference through his profession. His educational journey began at GS Murama, where he completed both his primary and ordinary level studies. Later, he moved to GS APAPERC Murambi, choosing the Humanities option for his advanced level studies.',
  },
  {
    id: 7,
    name: 'Niyomugabo Celestin',
    role: 'Founder and CEO of VONSUNG',
    location: 'RWANDA',
    image: niyomugabo,
    message:
      'Celestin Niyomugabo is an ASEF graduate from Gakenke District. He is a passionate, hardworking, and goal-oriented individual who has accomplished a lot in his career, even starting from his student days.',
  },
  {
    id: 8,
    name: 'Ntakirutimana Elie',
    role: 'Student at cornell  University',
    location: 'USA',
    image: elie,
    message:
      'I am known for my unwavering spirit, empathy, and resilience. In the face of adversity, I love demonstrating unshakable determination and a relentless pursuit of self-improvement. My defining trait is my deep desire to make a difference,with dreams rooted in altruism and a commitment to transforming the lives of the vulnerable.',
  },
  {
    id: 9,
    name: 'Nkurunziza Ghad',
    role: 'Student at Wesleyan University',
    location: 'USA',
    image: ghad,
    message:
      'Growing up as the firstborn, I grew up in a low-income family of two parents and four siblings in the rural area part of Rwanda, Burera-Butaro. Looking at myself, risk-taking, persistence and a growth mindset define the truest essence of my personality',
  },
  {
    id: 10,
    name: 'Nizeyimana Emmanuel',
    role: 'Student at Gahini GS',
    location: 'RWANDA',
    image: emmanuel,
    message:
      "Njyewe natangiye kwiga ntinze bitewe n'imyumvire ndetse n'ubushobozi bw'umuryango nkomokamo. Njyeze mu mwaka wa gatandatu w'amashuri abanza nafataga umwanya nkajya ku muhanda mugihe abanyeshuri biga mu mashuri yisumbuye babaga bahetse ibikapu bagiye",
  },
];

const Stories = ({ setChosenStory, setNavigateToSection }) => {
  return (
    <div className="w-full h-fit">
      <div className="w-full flex flex-col px-6 md:px-12 py-6 lg:px-32 lg:py-12">
        <div
          className="bg-cover bg-center flex flex-col lg:flex-row items-center justify-between font-rubik max-h-[250px] lg:h-[150px] w-full px-12 py-6 rounded-2xl"
          style={{ backgroundImage: `url(${frame})` }}
        >
          <div className="flex flex-col gap-1">
            <h1 className="text-secondary font-bold text-2xl lg:text-4xl font-quicksand">
              Stories
            </h1>
          </div>
          <p className=" w-full text-center lg:text-start lg:w-[40%]  text-white font-rubik text-base lg:text-lg">
            We share our student successful stories, learn more from our
            students' inspiring stories.
          </p>
        </div>

        <p className="text-primary text-2xl lg:text-4xl font-quicksand font-semibold mt-6 mb-12">
          Latest Alumni Stories
        </p>

        <div className="flex flex-row flex-wrap w-full">
          {stories.map((story) => {
            return (
              <div className="flex flex-col lg:flex-row gap-6 items-start w-full lg:w-[49%] px-1 py-4">
                <div className="w-fit lg:max-w-[160px] h-[160px] rounded-2xl bg-cover overflow-hidden mx-auto">
                  <img
                    src={story.image}
                    alt=""
                    className="w-full h-full bg-cover"
                  />
                </div>
                <div className="flex flex-col gap-2 w-full lg:w-2/3">
                  <h2 className="font-bold font-quicksand text-center lg:text-start">
                    {story.name}
                  </h2>
                  <div className="flex justify-between items-center">
                    <p className="font-rubik text-sm text-fontGrey text-center lg:text-start">
                      {story.role}
                    </p>
                    {story.date && (
                      <p className="font-rubik text-sm text-fontGrey mr-5">
                        {story.date}
                      </p>
                    )}
                  </div>

                  <div className="flex flex-col gap-2">
                    <div className="flex flex-col gap-2">
                      <BiSolidQuoteAltLeft
                        size={20}
                        color="#FDB935"
                        className="mx-auto lg:mx-0"
                      />
                      <p>
                        {story.message.length > 200
                          ? story.message.slice(0, 200) + '...'
                          : story.message}
                      </p>
                    </div>

                    <Link
                      to={'/stories/single'}
                      className="w-fit"
                      onClick={() => {
                        setChosenStory(story.id);
                      }}
                    >
                      <div className="flex gap-2 items-center w-fit cursor-pointer">
                        <p className="text-secondary font-rubik">Read more</p>
                        <LuMoveRight size={20} color="#FDB935" />
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Partners />
      <Footer setNavigateToSection={setNavigateToSection} />
    </div>
  );
};

export default Stories;
